'use strict';

var dashboard = angular.module('gymsystem.dashboard', []);

dashboard.directive('dashboard', ['$rootScope', '$timeout', 'util', 'widgets', 'live', 'server', 'alertProvider', 'confirm', '$document', 'modalUtils', '$filter', '$route', function($rootScope, $timeout, util, widgets, live, server, alertProvider, confirm, $document, modalUtils, $filter, $route) {
    return {
        restrict: 'E',
        templateUrl: 'views/dashboard.html',
        scope: {
            config: '=',
            type: '@'
        },
        link: function($scope) {
            $rootScope.currentDashboarScope = $scope;
            $scope.isFullscreen = $rootScope.isFullscreen;
            $scope.isSmallScreen = util.isSmallScreen;
            $scope.state = {resizing: false, selected: undefined, moving: undefined, edit: false, dashboard: null};
            $scope.panels = [];
            $scope.loadingStatus = {};
            var currentResizer;

            widgets.type = $scope.type = $scope.type || 'default';

            $scope.selectPanel = function(panel, $event) {
                var screen = $('#dscreen');
                var panels = screen.find('.dpanel');
                var focus = function(item) {
                    var that = this;
                    $timeout(function() { $rootScope.$apply(that, item.focus); });
                };
                for (var i=0; i < panels.length; ++i) {
                    if (panel && panels[i].id == 'panel' + panel.id) {
                        panels[i].style.zIndex = 1;
                        focus(panels[i]);
                    } else {
                        panels[i].style.zIndex = 0;
                    }
                }

                $scope.state.selected = panel;

                if ($event) {
                    $event.stopPropagation();
                }
            };

            function intersectingRect(r1,r2){
                var x=Math.max(r1.x,r2.x);
                var y=Math.max(r1.y,r2.y);
                var xx=Math.min(r1.x+r1.w,r2.x+r2.w);
                var yy=Math.min(r1.y+r1.h,r2.y+r2.h);
                return({x:x,y:y,w:xx-x,h:yy-y});
            }

            function isIntersecting(r1, x, y) {
                var r = {x:x, y:y, h:1, w:1};
                r = intersectingRect(r, r1);
                return r.w > 0 && r.h > 0;
            }

            function maxAreaInHist(height) {
                var stack = [];

                var i = 0;
                var max = 0;
                var x;
                var w;

                while (i < height.length) {
                    if (stack.length == 0 || height[stack[stack.length - 1]] <= height[i]) {
                        stack.push(i++);
                    } else {
                        var t = stack.pop();
                        var oldmax = max;
                        max = Math.max(max, height[t] * (stack.length == 0 ? i : i - stack[stack.length - 1] - 1));
                        if (max > oldmax) {
                            w = stack.length == 0 ? i : i - stack[stack.length - 1] - 1;
                            x = i - w;
                        }
                    }
                }
                return {area: max, x: x, w: w};
            }

            function maximalRectangle(matrix) {
                var m = matrix.length;
                var n = m == 0 ? 0 : matrix[0].length;
                var height = [];

                for (var i = 0; i < m; i++) {
                    var temp = [];
                    for (var j = 0; j < n+1; j++) {
                        temp.push(0);
                    }
                    height.push(temp);
                }

                var maxArea = 0;
                var x;
                var y;
                var w;
                var h;
                for (var i = 0; i < m; i++) {
                    for (var j = 0; j < n; j++) {
                        if (matrix[i][j] == '0') {
                            height[i][j] = 0;
                        } else {
                            height[i][j] = i == 0 ? 1 : height[i - 1][j] + 1;
                        }
                    }
                }

                for (var i = 0; i < m; i++) {
                    var a = maxAreaInHist(height[i]);
                    var area = a.area;
                    if (area > maxArea) {
                        maxArea = area;
                        x = a.x;
                        w = a.w;
                        h = area/w;
                        y = i - h + 1;
                    }
                }

                return {x: x, y:y, w:w, h:h, area: maxArea};
            }

            function removeAddPanels() {
                $scope.panels = $scope.panels.filter(function(panel) { return !panel.add; });
            }

            function splitPanelsToGrid() {
                var num_rows = 12, num_cols = 12;

                var rows = [];
                rows.length = num_rows;
                for (var row=0; row < rows.length; ++row) {
                    var cols = [];
                    cols.length = num_cols;
                    for (var col=0; col < num_cols; ++col) {
                        cols[col] = 1;
                        for (var i=0; i < $scope.panels.length; ++i) {
                            var p = $scope.panels[i];
                            var r = {x: p.left, y: p.top, w: p.width, h: p.height};
                            var x = col;
                            var y = row;
                            if (isIntersecting(r, x, y)) {
                                cols[col] = 0;
                            }
                        }
                    }
                    rows[row] = cols;
                }

                return rows;
            }

            function fillWithAddPanels() {
                removeAddPanels();

                while (true) {
                    // 1. Split screen into grid of 0:s and 1:s
                    var grid = splitPanelsToGrid();

                    // 2. Find free areas - add new panels if big enough
                    var rect = maximalRectangle(grid);
                    if (rect.w > 0 && rect.h > 0) {
                        $scope.addPanel({left: rect.x, top: rect.y, width: rect.w, height: rect.h, add:true});
                    } else {
                        break;
                    }
                }
            }

            function to_grid_x(x, round) {
                var grid_width = $scope.getGridWidth();
                var div = x / grid_width;
                return round ? Math.round(div) : Math.floor(div);
            }

            function to_grid_y(y, round) {
                var grid_height = $scope.getGridHeight();
                var div = y / grid_height;
                return round ? Math.round(div) : Math.floor(div);
            }

            function adjustPanelSize(panel) {
                var screen = $('#dscreen');
                var e = screen.find('#panel' + panel.id);
                if (e) {
                    e.find('.glyphicon-plus').css('line-height', (panel.height * $scope.getGridHeight() - 20) + 'px');
                }
            }

            function makeResizableDiv(element, containment, panel) {
                var resizers = element.querySelectorAll('.resizer');
                var original_width = 0;
                var original_height = 0;
                var original_x = 0;
                var original_y = 0;
                var original_mouse_x = 0;
                var original_mouse_y = 0;
                var minimum_size = 2;

                var max_x = 12;
                var max_y = 12;

                var setRect = function(x, y, w, h) {
                    if (panel.left == x && panel.top == y && panel.width == w && panel.height == h) {
                        return;
                    }

                    var min_widget_width = Math.max(minimum_size, (panel.widget ? panel.widget.minwidth : 0) || 0);
                    var can_change_w = w >= min_widget_width && x+w <= max_x && x >= 0;
                    var can_change_h = h >= minimum_size && y+h <= max_y && y >= 0;

                    if (can_change_w || can_change_h) {
                        var panels = $scope.panels.filter(function(p) { return panel != p && !p.add && p.widget; });
                        var r = {x: panel.left, y: panel.top, w: panel.width, h: panel.height};

                        if (can_change_w) {
                            for (var i=0; i < panels.length; ++i) {
                                var p = panels[i];
                                var r2 = {x: p.left, y: p.top, w: p.width, h: p.height};
                                var ir = intersectingRect({x: x, y: r.y, w: w, h: r.h }, r2);
                                if (ir.w > 0 && ir.h > 0) {
                                    can_change_w = false;
                                    break;
                                }
                            }
                            if (can_change_w) {
                                r.x = x;
                                r.w = w;
                            }
                        }

                        if (can_change_h) {
                            for (var i=0; i < panels.length; ++i) {
                                var p = panels[i];
                                var r2 = {x: p.left, y: p.top, w: p.width, h: p.height};
                                var ir = intersectingRect({x: r.x, y: y, w: r.w, h: h }, r2);
                                if (ir.w > 0 && ir.h > 0) {
                                    can_change_h = false;
                                    break;
                                }
                            }
                            if (can_change_h) {
                                r.y = y;
                                r.h = h;
                            }
                        }

                        if (!can_change_w && !can_change_h) {
                            return;
                        }

                        panel.left = r.x;
                        panel.top = r.y;
                        panel.width = r.w;
                        panel.height = r.h;

                        // Shrink panels
                        var non_widget_panels = $scope.panels.filter(function(p) { return !p.widget; });
                        for (var i=0; i < non_widget_panels.length; ++i) {
                            var p = non_widget_panels[i];
                            var r2 = {x: p.left, y: p.top, w: p.width, h: p.height};
                            var ir = intersectingRect(r, r2);
                            if (ir.w > 0 && ir.h > 0) {
                                if (ir.w == r2.w) {
                                    if (ir.y == r2.y) {
                                        p.top += ir.h;
                                    }
                                    p.height -= ir.h;
                                } else if (ir.h == r2.h) {
                                    if (ir.x == r2.x) {
                                        p.left += ir.w;
                                    }
                                    p.width -= ir.w;
                                } else if (ir.w < r2.w) {
                                    if (ir.y == r2.y) {
                                        p.top += ir.h;
                                    }
                                    p.height -= ir.h;
                                } else if (ir.h < r2.h) {
                                    if (ir.x == r2.x) {
                                        p.left += ir.w;
                                    }
                                    p.width -= ir.w;
                                }
                            }
                        }

                        // Expand panels
                        while (true) {
                            // 1. Split screen into grid of 0:s and 1:s
                            var grid = splitPanelsToGrid();

                            // 2. Find biggest empty area
                            var rect = maximalRectangle(grid);
                            if (!rect.h  || !rect.w) {
                                break;
                            }

                            // 3. See if any non-widget can expand into it - else done
                            var panel_changed = false;
                            for (var i=0; i < non_widget_panels.length; ++i) {
                                var p = non_widget_panels[i];
                                // Can expand upwards
                                if (p.width <= rect.w && p.left == rect.x && rect.y < p.top) {
                                    p.top = rect.y;
                                    p.height += rect.h;
                                    panel_changed = true;
                                // Can expand downwards
                                } else if (p.width <= rect.w && p.left == rect.x && rect.y > p.top) {
                                    p.height += rect.h;
                                    panel_changed = true;
                                // Can expand left
                                } else if (p.height <= rect.h && p.top == rect.y && rect.x < p.left) {
                                    p.left -= rect.w;
                                    p.width += rect.w;
                                    panel_changed = true;
                                // Can expand right
                                } else if (p.height <= rect.h && p.top == rect.y && rect.x > p.left) {
                                    p.width += rect.w;
                                    panel_changed = true;
                                }
                            }

                            if (!panel_changed) {
                                $scope.panels.push({left: rect.x, top:rect.y, height: rect.h, width:rect.w, remove: true});
                            }
                        }

                        // Remove empty panels and adjust size
                        for (var i=0; i <  $scope.panels.length; ++i) {
                            var p = $scope.panels[i];
                            if (p.remove || p.width <= 0 || p.height <= 0) {
                                $scope.panels.splice(i, 1);
                                i -= 1;
                            } else {
                                adjustPanelSize(p);
                            }
                        }

                        // Trigger reload of widget
                        if (panel.widget && panel.control && panel.control.reload) {
                            panel.control.reload();
                        }

                        $rootScope.$apply();
                    }
                };

                var resize = function(e) {
                    var dx = to_grid_x(e.clientX - original_mouse_x, true);
                    var dy = to_grid_y(e.clientY - original_mouse_y, true);
                    if (currentResizer.classList.contains('bottom-right')) {
                        var width = original_width + dx;
                        var height = original_height + dy;
                        setRect(original_x, original_y, width, height);
                    } else if (currentResizer.classList.contains('bottom-left')) {
                        var width = original_width - dx;
                        var height = original_height + dy;
                        setRect(original_x + dx, original_y, width, height);
                    } else if (currentResizer.classList.contains('top-right')) {
                        var width = original_width + dx;
                        var height = original_height - dy;
                        setRect(original_x, original_y + dy, width, height);
                    } else if (currentResizer.classList.contains('top-left')) {
                        var width = original_width - dx;
                        var height = original_height - dy;
                        setRect(original_x + dx, original_y + dy, width, height);
                    }
                };

                var stopResize = function() {
                    window.removeEventListener('mousemove', resize);
                    window.removeEventListener('mouseup', stopResize);
                    document.body.style.cursor = '';

                    fillWithAddPanels();

                    $rootScope.$apply(function() {
                        $scope.state.resizing = false;
                    });
                };

                var mouseDown = function(e) {
                    currentResizer = e.target;
                    e.preventDefault();
                    original_width = panel.width;
                    original_height = panel.height;
                    original_x = panel.left;
                    original_y = panel.top;
                    original_mouse_x = e.clientX;
                    original_mouse_y = e.clientY;
                    window.addEventListener('mousemove', resize);
                    window.addEventListener('mouseup', stopResize);

                    document.body.style.cursor = getComputedStyle(currentResizer, null).getPropertyValue('cursor');

                    removeAddPanels();

                    $rootScope.$apply(function() {
                        $scope.state.resizing = true;
                    });
                };

                for (var i = 0; i < resizers.length; i++) {
                    resizers[i].addEventListener('mousedown', mouseDown);
                }
            }

            function arePanelsOverlappingWith(panel_id, rect) {
                for (var i=0; i < $scope.panels.length; ++i) {
                    var p = $scope.panels[i];
                    if (panel_id == p.id) {
                        continue;
                    }

                    var ir = intersectingRect(rect, {x: p.left, y: p.top, w: p.width, h: p.height});
                    if (ir.w > 0 && ir.h > 0) {
                        return true;
                    }
                }

                return false;
            }

            function getOverlappingPanels(panel_id, rect) {
                var res = [];
                for (var i=0; i < $scope.panels.length; ++i) {
                    var p = $scope.panels[i];
                    if (panel_id == p.id) {
                        continue;
                    }
                    var ir = intersectingRect(rect, {x: p.left, y: p.top, w: p.width, h: p.height});
                    if (ir.w > 0 && ir.h > 0) {
                        res.push(p);
                    }
                }

                return res;
            }

            $scope.onPanelMoveStart = function(event) {
                removeAddPanels();
                var id = Number(event.target.id.substring(5));
                var p = _.findWhere($scope.panels, {id: id});
                $scope.state.moving = p;
                $scope.state.move_start = {left: p.left, top: p.top };
            };

            $scope.onPanelMoveStop = function(event, ui) {
                var p = $scope.state.moving;

                var grid_width = $scope.getGridWidth();
                var grid_height = $scope.getGridHeight();
                var snapped = {x: to_grid_x(Math.max(0, ui.position.left)), y: to_grid_y(Math.max(0, ui.position.top)), w: p.width, h: p.height };

                var overlapping = arePanelsOverlappingWith(p.id, snapped);
                p.left = overlapping ? $scope.state.move_start.left : snapped.x;
                p.top = overlapping ? $scope.state.move_start.top : snapped.y;
                var pe = $('#panel' + p.id);
                pe.css('left', p.left*grid_width + 'px');
                pe.css('top', p.top*grid_height + 'px');

                $scope.state.moving = undefined;
                $scope.state.move_start = undefined;
                fillWithAddPanels();
                $rootScope.$apply();
            };

            $scope.onPanelMoving = function(event, ui) {
                var grid_width = $scope.getGridWidth();
                var grid_height = $scope.getGridHeight();
                var rect = {x: ui.position.left / grid_width, y: ui.position.top / grid_height, w: $scope.state.moving.width, h: $scope.state.moving.height};
                var overlaps = getOverlappingPanels($scope.state.moving.id, rect);
                if (overlaps.length == 1) {
                    var o = overlaps[0];
                    // Limit moving to blocks of same size
                    if (o.width != $scope.state.moving.width || o.height != $scope.state.moving.height) {
                        return;
                    }

                    var ir = intersectingRect({x: o.left, y: o.top, w: o.width, h: o.height}, rect);
                    // Check overlap width/height must be at least 2/3
                    if (ir.w * ir.h < Math.min(rect.w*rect.h*2/3, o.width*o.height*2/2)) {
                        return;
                    }

                    // Check that panel fits there (always OK because of size check above)
                    //if (arePanelsOverlappingWith($scope.state.moving.id, {x: $scope.state.move_start.left, y: $scope.state.move_start.top, w: o.width, h: o.height})) {
                    //    return;
                    //}

                    var u = {left: o.left, top: o.top};
                    o.left = $scope.state.move_start.left;
                    o.top = $scope.state.move_start.top;
                    $scope.state.move_start = u;
                }
            };

            $scope.addPanel = function(panel) {
                var newid = ($scope.panels.length == 0 ? 0 : _.max(_.pluck($scope.panels, 'id'))) + 1;
                panel = angular.copy(panel);
                panel.id = newid;
                panel.control = {};

                if (panel.widget) {
                    panel.name = panel.widget.title;
                }

                $scope.panels.push(panel);
                $timeout(function() {
                    var screen = $('#dscreen');
                    var e = screen.find("#panel{0}".format(panel.id))[0];
                    if (e) {
                        makeResizableDiv(e, screen, panel);
                    }

                    adjustPanelSize(panel);
                });
            };

            $scope.addPanelClicked = function(panel, $event) {
                util.showDataDialog({ controller: 'WidgetDataCtrl', datatype: 'widget', width: panel.width }).result.then(function(widget) {
                    panel.add = false;
                    panel.name = widget.title;
                    panel.widget = widget;
                    fillWithAddPanels();
                });

                if ($event) {
                    $event.stopPropagation();
                }
            };

            $scope.changePanelClicked = function(panel, $event) {
                // Fix for save button, if id is not set button will display "Copy" instead of "Save". util.js:1190
                panel.widget.id = true;

                util.showDataDialog({ controller: 'WidgetDataCtrl', datatype: 'widget', width: panel.width, item: panel.widget }).result.then(function(widget) {
                    if (widget) {
                        panel.name = widget.title;
                        panel.widget = widget;
                    } else {
                        var i = $scope.panels.indexOf(panel);
                        if (i != -1) {
                            $scope.panels.splice(i, 1);
                            fillWithAddPanels();
                        }
                    }
                });

                if ($event) {
                    $event.stopPropagation();
                }
            };

            function removePanel(e) {
                var input = document.activeElement && document.activeElement && document.activeElement.tagName && document.activeElement.tagName.toLowerCase() == 'input';
                if ($scope.state.edit && $scope.state.selected && e.key == 'Delete' && !modalUtils.modalsExist() && !input) {
                    var i = $scope.panels.indexOf($scope.state.selected);
                    if (i != -1) {
                        $scope.panels.splice(i, 1);
                        fillWithAddPanels();
                        $rootScope.$apply();
                    }
                }
            }

            $document.bind('keydown', removePanel);

            $scope.$on('$destroy', function () {
                $document.unbind('keydown', removePanel);
                $scope.removeWatch?.();
            });

            $scope.dashboards = [];
            function getDashboards() {
                server.get('/api/dashboard/get', { type: ($scope.type || 'default') }).then(function(result) {
                    result.forEach(function(d) {
                        d.config = JSON.parse(d.config);
                        d.name = util.t(d.name);
                    });
                    if (!angular.equals($scope.dashboards, result)) {
                        var current_dashboard = angular.copy($scope.state.dashboard);
                        $scope.dashboards = result;

                        if (!$scope.state.edit) {
                            if ($scope.dashboards.length) {
                                if ($scope.state.dashboard) {
                                    $scope.state.dashboard = _.findWhere($scope.dashboards, {id: $scope.state.dashboard.id});
                                }

                                if (!$scope.state.dashboard) {
                                    var s = $rootScope.currentStaff.staff_client_settings || {};
                                    if ($scope.type == 'economy') {
                                        if (s.economydashboard) {
                                            $scope.state.dashboard = _.findWhere($scope.dashboards, {id: s.economydashboard});
                                        } else {
                                            $scope.state.dashboard = _.findWhere($scope.dashboards, {name: 'Ekonomi'});
                                        }
                                    } else if (s.dashboard) {
                                        $scope.state.dashboard = _.findWhere($scope.dashboards, {id: s.dashboard});
                                    }

                                    if (!$scope.state.dashboard) {
                                        $scope.state.dashboard = $scope.dashboards[0];
                                    }
                                }
                            }

                            if (!angular.equals(current_dashboard, $scope.state.dashboard)) {
                                $scope.loadDashboard();
                            }
                        }
                    }
                });
            }

            $scope.loadDashboard = function() {
                if (!util.isSmallScreen()) {
                    var width = $('#dscreen').outerWidth();
                    var height = $('#dscreen').outerHeight();

                    if (!width || !height) {
                        $timeout($scope.loadDashboard);
                        return;
                    }
                }

                $scope.panels = [];
                var dashboard = $scope.state.dashboard;
                if (!dashboard || !dashboard.config || !dashboard.config.widgets) {
                    if ($scope.state.edit) {
                        $scope.addPanel({left: 0, top: 0, width: 12, height: 12, add: true});
                    }
                    return;
                }

                dashboard.config.widgets.forEach(function(panel) {
                    $scope.addPanel({left: panel.rect.x, top: panel.rect.y, width: panel.rect.w, height: panel.rect.h, add: false, widget: panel.widget });
                });


                if ($scope.state.edit) {
                    fillWithAddPanels();
                }
            };

            live.subscribe({type: 'dashboard', scope: $scope, callback: getDashboards});
            getDashboards();

            $scope.removeWatch = $rootScope.$watch('currentStaff.client_settings', function() {
                getDashboards();
            }, true);

            $scope.saveClientSettings = function() {
                if ($scope.state.dashboard) {
                    var s = $rootScope.currentStaff.staff_client_settings || {};
                     if ($scope.type == 'economy') {
                        if (s.economydashboard != $scope.state.dashboard.id) {
                            s.economydashboard = $scope.state.dashboard.id;
                            $rootScope.currentStaff.staff_client_settings = s;
                            server.post('/api/staff/client_settings/change', s);
                        }
                    } else if (s.dashboard != $scope.state.dashboard.id) {
                        s.dashboard = $scope.state.dashboard.id;
                        $rootScope.currentStaff.staff_client_settings = s;
                        server.post('/api/staff/client_settings/change', s);
                    }
                }
            };

            $scope.dashboardSelected = function() {
                $scope.loadDashboard();
                $scope.saveClientSettings();
            };

            $scope.showManageAccessButton = function() {
                return $scope.state.edit && !$scope.state.isChoosingTemplate;
            };

            $scope.showBackToEditingButton = function() {
                return $scope.state.edit && $scope.state.isChoosingTemplate && !util.isSmallScreen() && $scope.state.canGoBackEditing;
            };

            $scope.showChangeTemplateButton = function() {
                return $scope.state.edit && !$scope.state.isChoosingTemplate && !util.isSmallScreen();
            };

            $scope.showSaveButton = function() {
                return $scope.state.edit && !$scope.state.isChoosingTemplate;
            };

            $scope.showCancelButton = function() {
                return ($scope.state.add && !$scope.state.canGoBackEditing) || ($scope.state.edit && !$scope.state.isChoosingTemplate);
            };

            $scope.showChoosingTemplateText = function() {
                return $scope.state.edit && $scope.state.isChoosingTemplate && !util.isSmallScreen();
            };

            $scope.choosingTemplateText = function() {
                return $scope.state.canGoBackEditing ? $filter('translate')('CHANGE_DASHBOARD_TEMPLATE') : $filter('translate')('Choose a template to start from');
            };

            $scope.save = function() {
                $scope.loadingStatus.saving = true;
                removeAddPanels();

                var dashboard = {};
                dashboard.config = JSON.stringify({
                    widgets: $scope.panels.map(function(panel) {
                        return {
                            rect: {x: panel.left, y: panel.top, w: panel.width, h: panel.height},
                            widget: panel.widget
                        };
                    }),
                    access: angular.copy($scope.state.dashboard.config.access)
                });

                if ($scope.state.add) {
                    dashboard.name = $scope.state.dashboard.name;
                    dashboard.type = $scope.type;
                } else {
                    dashboard.id = $scope.state.dashboard.id;
                    dashboard.name = $scope.state.dashboard.name;
                }

                var url = $scope.state.add ? '/api/dashboard/add' : '/api/dashboard/change';
                server.post(url, dashboard).then(function(result) {
                    if (result.success) {
                        util.waitFor($scope, function() {return _.findWhere($scope.dashboards, {id: result.data.id});}).then(function() {
                            $scope.state.dashboard = _.findWhere($scope.dashboards, {id: result.data.id});
                            $timeout($scope.loadDashboard);
                            $scope.saveClientSettings();
                        });
                        $scope.state.add = false;
                        $scope.state.edit = false;
                    } else {
                        alertProvider.modal('Error', 'Failed to save dashboard');
                    }

                    $scope.loadingStatus.saving = false;
                });
            };

            $scope.edit = function() {
                $scope.state.isChoosingTemplate = false;
                $scope.state.canGoBackEditing = true;
                $scope.state.edit = true;
                $scope.state.dashboard = angular.copy($scope.state.dashboard);
                $timeout($scope.loadDashboard);
            };

            $scope.setAddMode = function() {
                $scope.state.isChoosingTemplate = true;
                $scope.state.canGoBackEditing = false;
                $scope.state.add = true;
                $scope.state.edit = true;
                $scope.state.dashboard = $scope.state.dashboard ? {id: $scope.state.dashboard.id} : {};
                $scope.state.dashboard.config = {access: { 'change_persons': [$rootScope.currentStaffId] }};
                $timeout($scope.loadDashboard);
            };

            $scope.copy = function() {
                $scope.state.add = true;
                $scope.state.edit = true;
                $scope.state.dashboard = angular.copy($scope.state.dashboard);
                $scope.state.dashboard.name = '';
                if (!$scope.state.dashboard.config.access) {
                    $scope.state.dashboard.config.access = { 'change_persons': [$rootScope.currentStaffId] };
                }
                $timeout($scope.loadDashboard);
            };

            $scope.cancel = function() {
                $scope.state.add = false;
                $scope.state.edit = false;
                $scope.state.isChoosingTemplate = false;
                if ($scope.state.dashboard) {
                    $scope.state.dashboard = _.findWhere($scope.dashboards, {id: $scope.state.dashboard.id});
                }
                $timeout($scope.loadDashboard);
            };

            $scope.remove = function() {
                confirm.show('Are you sure you want to remove the dashboard?').then(function() {
                    server.post('/api/dashboard/remove', null, {id: $scope.state.dashboard.id }).then(function(result) {
                        if (result.success) {
                            $scope.state.dashboard = null;
                            $timeout($scope.loadDashboard);
                        } else {
                            alertProvider.modal('Error', util.t('Failed to remove {0}').format(util.t('dashboard')));
                        }
                    });
                });
            };

            $scope.fullscreen = function() {
                document.documentElement.requestFullscreen().then(function() {
                    $rootScope.$apply();
                });
            };

            $scope.canSubmit = function() {
                if ($scope.state.add) {
                    return $scope.state.dashboard.name;
                } else {
                    return true;
                }
            };

            $scope.getScreenStyle = function() {
                if ($rootScope.isFullscreen()) {
                    return {width: 'calc(100vw - 30px)', height: 'calc(100vh - 30px)'};
                }

                var height = 30 + $('#content').height() - $('#dscreen').offset().top;
                return {
                    width: 'calc(100% + 20px)',
                    height: height + 'px',
                    'margin-left': '-10px',
                    'margin-right': '10px'
                };
            };

            $scope.getGridWidth = function() {
                return $('#dscreen').outerWidth() / 12;
            };

            $scope.getGridHeight = function() {
                return $('#dscreen').outerHeight() / 12;
            };

            $scope.getPanelStyle = function(panel) {
                if ($scope.state.selected && $scope.state.selected != panel && $scope.state.selected.full) {
                    return {display: 'none'};
                }

                var grid_width = $scope.getGridWidth();
                var grid_height = $scope.getGridHeight();

                return {
                    left: panel.left * grid_width,
                    top: panel.top * grid_height,
                    width: panel.width * grid_width,
                    height: panel.height * grid_height
                };
            };

            $scope.smallScreenPanelOrder = function(panel) {
                var res = '';
                if (panel.top < 10) {
                    res += '0';
                }
                res += panel.top;
                if (panel.left < 10) {
                    res += '0';
                }
                res += panel.left;
                return res;
            };

            $scope.getWidgetStyle = function(panel) {
                var grid_height = $scope.getGridHeight();
                return {
                    width: 'calc(100% - 10px)',
                    height: (panel.height * grid_height - ($scope.state.edit || (panel.widget && panel.widget.showheader) ? 55 : 30)) + 'px',
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    margin: '5px'
                };
            };

            $scope.getInnerPanelClass = function(panel) {
                var classes = [];
                if ($scope.state.moving == panel) {
                    classes.push('moving');
                }

                if ($scope.state.edit && (panel.add || !panel.widget)) {
                    classes.push('clickable');
                }

                return classes;
            };

            $scope.toggleFullSize = function(panel, $event) {
                panel.full = !panel.full;
                $scope.selectPanel(panel);

                var grid_width = $scope.getGridWidth();
                var grid_height = $scope.getGridHeight();

                var to;

                if (panel.full) {
                    $scope.state.original_size = {left: panel.left, top: panel.top, width: panel.width, height: panel.height};
                    to = {left: 0, top: 0, width: 12, height: 12};
                } else {
                    var s = $scope.state.original_size;
                    to = {left: s.left, top: s.top, width: s.width, height: s.height};
                }

                $("#dscreen #panel" + panel.id).animate({
                    left: (to.left*grid_width) + 'px',
                    top: (to.top*grid_height) + 'px',
                    width: (to.width*grid_width) + 'px',
                    height: (to.height*grid_height) + 'px'
                }, 500, function() {
                    panel.left = to.left;
                    panel.top = to.top;
                    panel.width = to.width;
                    panel.height = to.height;
                    if (panel.control && panel.control.sizeChanged) {
                        panel.control.sizeChanged(panel.width * $scope.getGridWidth(), panel.height * $scope.getGridHeight());
                    }
                    $scope.$apply();
                });

                if ($event) {
                    $event.stopPropagation();
                }
            };

            $scope.manageAccess = function() {
                var item = angular.copy($scope.state.dashboard.config.access);
                item.name =  util.t('access for dashboard'); // To get title correct
                util.showDataDialog({ controller: 'AccessDataCtrl', datatype: 'access', item: item, mode: 'change'}).result.then(function(access) {
                    delete access.name;
                    delete access.id;
                    $scope.state.dashboard.config.access = access;
                });
            };

            var layouts = [{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}];
            $scope.getLayouts = function() {
                return layouts;
            };

            $scope.setLayout = function(layout) {
                $scope.state.isChoosingTemplate = false;
                var width = 12;
                var height = 12;

                var add = function(x, y, w, h) {
                    if (w == 'fill') {
                        w = width - x;
                    }
                    if (h == 'fill') {
                        h = height - y;
                    }
                    $scope.addPanel({left: x, top: y, width: w, height: h});
                };

                $scope.panels = [];
                switch (layout.id) {
                    case 1:
                        add(0, 0, width/2, height/2);
                        add(width/2, 0, width/2, height/2);
                        add(0, height/2, width/2, 'fill');
                        add(width/2, height/2, 'fill', 'fill');
                        break;
                    case 2:
                        add(0, 0, 'fill', height/3);
                        add(0, height/3, width/2, 'fill');
                        add(width/2, height/3, 'fill', 'fill');
                        break;
                    case 3:
                        add(0, 0, width/2, height/3);
                        add(width/2, 0, 'fill', height/3);
                        add(0, height/3, width/2, height/3);
                        add(width/2, height/3, 'fill', height/3);
                        add(0, 2*height/3, width/2, 'fill');
                        add(width/2, 2*height/3, 'fill', 'fill');
                        break;
                    case 4:
                        add(0, 0, width/2, height/3);
                        add(0, height/3, width/2, height/3);
                        add(0, 2*height/3, width/2, 'fill');
                        add(width/2, 0, 'fill', 'fill');
                        break;
                    case 5:
                        add(0, 0, width/3, 'fill');
                        add(width/3, 0, width/3, 'fill');
                        add(2*width/3, 0, 'fill', 'fill');
                        break;
                    case 6:
                        add(0, 0, width/4, 3*height/4);
                        add(width/4, 0, width/4, 3*height/4);
                        add(2*width/4, 0, width/4, 3*height/4);
                        add(3*width/4, 0, width/4, 3*height/4);
                        add(0, 3*height/4, 'fill', 'fill');
                        break;
                    default:
                        server.get('/api/dashboard/template/get', {name: layout.id}).then(function(res) {
                            var config = JSON.parse(res.config);
                            $scope.state.dashboard.name = res.name.capitalize();
                            config.widgets.forEach(function(panel) {
                                $scope.addPanel({left: panel.rect.x, top: panel.rect.y, width: panel.rect.w, height: panel.rect.h, add: false, widget: panel.widget });
                            });
                            $scope.state.isChoosingTemplate = false;
                        });
                }
            };

            var disabled = function() { return !$scope.state.dashboard || !$scope.state.dashboard.config.access; };
            var tooltip = function() { return disabled() && 'Insufficient access rights'; };

            $scope.manageConfig = {
                title: 'Manage',
                actions: [
                    {title: 'Copy', visible: function() { return $scope.state.dashboard && !util.isSmallScreen(); }, onClick: $scope.copy },
                    {title: 'Create new', visible: function() { return !util.isSmallScreen(); }, onClick: $scope.setAddMode},
                    {title: 'Edit', disabled: disabled, onClick: $scope.edit, tooltip: tooltip },
                    {title: 'Remove', disabled: disabled, onClick: $scope.remove, tooltip: tooltip},
                    {title: 'Show in fullscreen', visible: function() { return $scope.state.dashboard && !util.isSmallScreen(); }, onClick: $scope.fullscreen}
                ]
            };

            $scope.changeTemplate = function() {
                $scope.state.isChoosingTemplate = true;
                $scope.state.canGoBackEditing = true;
            };

            $scope.backToEditing = function() {
                $scope.state.isChoosingTemplate = false;
                $scope.state.canGoBackEditing = false;
            };

            var driver = new window.Driver({
                animate: false,
                opacity: 0,
                doneBtnText: $filter('translate')('Next chapter'),
                closeBtnText: $filter('translate')('Close'),
                nextBtnText: $filter('translate')('Next'),
                prevBtnText: $filter('translate')('Previous')
            });

            function startGuide() {
                var el = document.querySelector('multibutton span.ladda-label');
                var compareText = $filter('translate')('Manage') + ' ';
                if (el.outerText === compareText) {
                    driver.highlight({
                        element: el,
                        popover: {
                            title: '<span style="white-space: nowrap;">Skräddarsy din egen startsida!</span>',
                            description: 'Klick på <strong>Hantera</strong> -> <strong>Skapa ny</strong> för att välja bland våra nya anpassningsbara mallar.',
                            position: 'bottom'
                        }
                    });
                }
            }

            var checkExist = setInterval(function() {
                if (!$rootScope.isSmallScreen() && $('multibutton span.ladda-label').length) {
                    clearInterval(checkExist);
                    var visitedGuideTour = $rootScope.currentStaff.visited_guide_tour;
                    if (!visitedGuideTour || !visitedGuideTour.dashboard) {
                        startGuide();
                        server.post('/api/member/guide/set', null, {chapter: 'dashboard'});
                    }
                }
            }, 100);

            if ($scope.control) {
                $scope.control.selectDashboard = function(id) {
                    $scope.state.dashboard = _.findWhere($scope.dashboards, {id});
                    $scope.dashboardSelected();
                }
            }
        }
    };
}]);

dashboard.factory('widgets', ['$rootScope', 'server', 'live', 'util', function($rootScope, server, live, util) {
    var widgets = {};

    var doors = [];
    function setDoors() {
        if ($rootScope.staffs) {
            doors.length = 0;
            $rootScope.staffs.forEach(function(r) {
                if (r.active && r.type == 'resource' && (r.resourceType == 'door' || r.resourceType == 'qrcode_entry')) {
                    doors.push(r);
                }
            });
        }
    }
    $rootScope.waitFor(['staffs']).then(setDoors);
    live.subscribe({ type: 'user', callback: setDoors });
    if ($rootScope.speedy) {
        $rootScope.$on('ApiDataLoaded', (event, uid) => {
            if (uid.startsWith('user.')) {
                setDoors();
            }
        });
    }

    // FIXME: This should be loaded on demand instead. Now it's loaded on startup and then updated all the time for no reason
    var staffsAndResources = [];
    function setStaffsAndResources() {
        if ($rootScope.staffs) {
            staffsAndResources.length = 0;
            if ($rootScope.speedy) {
                let updateList = (list) => {
                    list.forEach(r => {
                        $rootScope.getMember(r.id);
                        if (!staffsAndResources.find(sr => sr.id === r.id)) {
                            staffsAndResources.push(r);
                        }
                    });
                    staffsAndResources.sort((a, b) => a.name.localeCompare(b.name));
                }

                server.get('/api/staff/get', {site_id: $rootScope.selectedSite.id, inactive: false, compact: true, fields: 'id,name'}).then(updateList);
                server.get('/api/resource/get', {site_id: $rootScope.selectedSite.id, inactive: false}).then(updateList);
            } else {
                $rootScope.staffs.forEach(function(r) {
                    if (!r.active) { return; }
                    staffsAndResources.push({ id: r.id, name: r.name });
                });
            }
        }
    }

    $rootScope.waitFor(['staffs', 'sites']).then(setStaffsAndResources);
    live.subscribe({ type: 'user', callback: setStaffsAndResources });
    if ($rootScope.speedy) {
        $rootScope.pubsub('selectedSite', setStaffsAndResources);
    }

    var workoutCategories = [];
    function getworkoutCategories() {
        workoutCategories.length = 0;
        $rootScope.workoutcategories.forEach(function(wt) {
            workoutCategories.push({id: wt.id, name: wt.name});
        });
    }
    $rootScope.waitFor(['workoutcategories']).then(getworkoutCategories);

    var resourceBookingsCategories = [];
    function getresourceBookingsCategories() {
        resourceBookingsCategories.length = 0;
        $rootScope.resourcebookingcategories.forEach(function(rbc) {
            resourceBookingsCategories.push({id: rbc.id, name: rbc.name});
        });
    }
    $rootScope.waitFor(['resourcebookingcategories']).then(getresourceBookingsCategories);

    var userfields = [];
    var setUserFields = function() {
        if ($rootScope.fields.user) {
            userfields.length = 0;
            $rootScope.fields.user.forEach(function(field) {
                if (!field.show || field.type == 'password') { return; }
                userfields.push({ id: field.name, name: util.t(field.title) });
            });
        }
    };
    $rootScope.waitFor(['fields']).then(setUserFields);

    var widget_list = [
        {
            id: 'clockwidget',
            name: 'Time',
            settings: [
                {hint: 'FORMATSTRINGMORE'},
                {name: 'format', title: 'Format', type: 'text', required: true},
                {name: 'font_size', title: 'Font size', type: 'number', required: true}
            ],
            initial: {
                format: 'HH:mm:ss',
                font_size: 44
            }
        },
        {
            id: 'todolist',
            name: 'ToDo',
            permissions: 'Todo handling',
            settings: [
                {name: 'columns', title: 'Columns', type: 'multiselect', version: 2, required: true, data: [{id: 'todo', name: 'ToDo'}, {id: 'dueDate', name: 'Due date'}, {id: 'responsible.name', name: 'Responsible'}]}
            ],
            initial: {
                columns: ['todo', 'dueDate']
            }
        },
        /*{
            id: 'economydata',
            name: 'Ekonomidata',
            permissions: 'Economy',
            minwidth: 2,
            settings: [
                {name: 'fromDate', title: 'From date', type: 'date', required: true},
                {name: 'toDate', title: 'To date', type: 'date', required: true},
                {name: 'data', title: 'Ekonomidata', type: 'multiselect', version: 2, required: true,
                    data: [
                        {id: 'totinc', name: 'Totala inkomster'},
                        {id: 'res', name: 'Årets resultat'},
                        {id: 'net', name: 'Nettoomsättning'},
                        {id: 'misc', name: 'Övrig omsättning'},
                        {id: 'due', name: 'Förfallna leverantörsfakturor'},
                        {id: 'totexp', name: 'Totala utgifter'},
                        {id: 'ass', name: 'Tillgångar'},
                        {id: 'winmar', name: 'Vinstmarginal'},
                        {id: 'cash', name: 'Kassalikviditet'}
                    ]
                }
            ],
            initial: {
                fromDate: Date.newFull(new Date().getFullYear() + '-01-01'),
                toDate: Date.newFull(new Date().getFullYear() + '-12-31'),
                data: ['totinc', 'res', 'net', 'due']
            }
        },
        {
            id: 'incomesexpenses',
            name: 'Intäkter och utgifter',
            permissions: 'Economy',
            minwidth: 4,
            settings: [
                {name: 'fromDate', title: 'From date', type: 'date', required: true},
                {name: 'toDate', title: 'To date', type: 'date', required: true},
                {name: 'zoom', title: 'Visa zoom', type: 'checkbox'},
            ],
            initial: {
                fromDate: Date.newFull(new Date().getFullYear() + '-01-01'),
                toDate: Date.newFull(new Date().getFullYear() + '-01-05'),
                zoom: false
            }
        },
        {
            id: 'liquidity',
            name: 'Likviditet',
            permissions: 'Economy',
            minwidth: 4,
            settings: [
                {name: 'fromDate', title: 'From date', type: 'date', required: true},
                {name: 'toDate', title: 'To date', type: 'date', required: true},
                {name: 'zoom', title: 'Visa zoom', type: 'checkbox'},
            ],
            initial: {
                fromDate: Date.newFull(new Date().getFullYear() + '-01-01'),
                toDate: Date.newFull(new Date().getFullYear() + '-01-05'),
                zoom: false
            }
        },*/
        {
            id: 'reportwidget',
            permissions: 'Show statistics',
            name: 'Report',
            type: 'report',
            settings: [
                {name: 'report_id', title: 'Report', type: 'select', data: () => $rootScope.reports?.map(r => ({id: r.id, name: r.data.name})), useId: true, required: true, placeholder: 'Choose report'},
            ]
        },
        {
            id: 'iframewidget',
            name: 'External source',
            settings: [
                {name: 'url', title: 'URL', type: 'url', required: true},
                {name: 'pass_zoezi_user_id', title: 'Send logged in user', type: 'checkbox'}
            ]
        },
        {
            id: 'logo',
            name: 'Logo',
            settings: [
                {name: 'small', title: 'Small logo', type: 'checkbox'}
            ]
        },
        {
            id: 'imagewidget',
            name: 'Image',
            settings: [
                { name: 'imagekey', title: 'Image', type: 'field', required: true, field: 'image-storage', option: {originType: 'dashboard', imageOnly: true, squareThumbnail: false} }
            ]
        },
        {
            id: 'schedule',
            name: 'Schedule',
            settings: [
                { name: 'tabs', title: 'Tabs', type: 'multiselect', version: 2, required: true, data: [{id: 'my', name: 'My schedule'}, {id: 'myServiceHours', name: 'My service hours'}, {id: 'all', name: 'All staff'}, {id: 'resources', name: 'All resources'}, {id: 'weeklyScheduleResource', name: 'Weekly schedule'}]}
            ],
            initial: {
                tabs: ['my', 'myServiceHours', 'all', 'resources', 'weeklyScheduleResource']
            }
        },
        {
            id: 'customschedule',
            name: 'Custom schedule',
            settings: [
                { name: 'resources', title: 'Resources', type: 'multiselect', version: 2, required: true, data: staffsAndResources },
                { name: 'hideEmpty', title: 'Hide empty columns', type: 'checkbox' },
                { name: 'weekResources', title: 'Weekly schedule', type: 'checkbox', helpText: 'WEEKLYSCHEDULEINFO' }
            ],
            initial: []
        },
        {
            id: 'weeklyschedule',
            name: 'Weekly schedule',
            settings: [
                { name: 'resources', title: 'Resources', type: 'multiselect', version: 2, required: true, data: staffsAndResources },
            ],
            initial: []
        },
        {
            id: 'opendoor',
            name: 'Open door',
            permissions: 'Entry handling',
            settings: [
                {name: 'door', title: 'Door', type: 'select', data: doors, useId: true, required: true, placeholder: 'Choose door'},
                {name: 'buttontext', title: 'Button text', type: 'text', required: true}
            ],
            initial: {
                buttontext: 'Open {name}'
            },
            loadData: () => {
                if ($rootScope.speedy) {
                    return $rootScope.loadActiveResourcesForSite().then(() => setDoors())
                }
            }
        },
        {
            id: 'upcomingactivity',
            name: 'Your upcoming activity',
            permissions: 'Show schedule',
            settings: []
        },
        {
            id: 'economyaddtransaction',
            name: 'Add transaction',
            permissions: 'Economy',
            type: 'economy',
            settings: [],
        },
        {
            id: 'economycertifyincomes',
            name: 'Certify incomes',
            permissions: 'Economy',
            type: 'economy',
            settings: [],
        },
        {
            id: 'economycertifycosts',
            name: 'Certify payments / costs',
            permissions: 'Certify costs',
            type: 'economy',
            settings: [
                {name: 'types', title: 'Cost types', type: 'multiselect', version: 2, required: false, data: [
                    {id: 'receipt', name: 'Receipts'},
                    {id: 'supplierinvoice', name: 'Supplier invoices'},
                    {id: 'travelcompensation', name: 'Travel bills'},
                    {id: 'outlay', name: 'Outlays'},
                    {id: 'valuecard', name: 'Value cards'}
                ]}
            ]
        },
        {
            id: 'payoutlist',
            name: 'Payouts',
            permissions: 'Economy',
            type: 'economy',
            settings: []
        },
        {
            id: 'upcomingactivitylist',
            name: 'Your upcoming activities',
            permissions: 'Show schedule',
            settings: [
                {name: 'warnNumBooked', title: 'Warning if number of booked is less than', required: true, type: 'number', min: 1},
                {name: 'warnHours', title: 'Warning', required: true, type: 'infoNumber', info: 'hours before', max: 23},
                {name: 'columns', title: 'Columns', type: 'multiselect', version: 2, required: true, data: [{id:'startDate',name:'Date'},{id:'startTime',name:'Time'},{id:'origin.workoutType.name',name:'Activity'},{id:'origin.numBooked',name:'Total booked'},{id:'age',name:'Age'}]}
            ],
            initial: {
                warnNumBooked: 2,
                warnHours: 1,
                columns: ['startDate', 'startTime', 'origin.workoutType.name', 'origin.numBooked', 'age']
            }
        },
        {
            id: 'economyoverview',
            name: 'Historical and upcoming payments',
            permissions: 'Economy',
            type: 'economy',
            settings: [
                {name: 'tabs', title: 'Tabs', type: 'multiselect', required: true, data: [
                    {id: 'unpaid', name: 'Unpaid'},
                    {id: 'pending', name: 'Pending payments'},
                    {id: 'sent', name: 'Sent payments'},
                    {id: 'giftcard', name: 'Value cards'},
                    {id: 'debtcollection', name: 'Debt collection'},
                    {id: 'history', name: 'History'}
                ]}
            ]
        },
        {
            id: 'buttonlist',
            name: 'Buttons',
            settings: [
                { name: 'buttons', title: 'Buttons', type: 'multiselect', required: true, version: 2, data: [
                    { id: 'addMember', name: 'Add new customer' },
                    { id: 'addGroup', name: 'Add new group' },
                    { id: 'addWorkout', name: 'New activity' },
                    { id: 'openCashier', name: 'Open cashier' },
                ]}
            ]
        },
        {
            id: 'allactivities',
            name: 'All activities',
            permissions: 'Show schedule',
            settings: [
                {name: 'category', title: 'Show category', type: 'multiselect', version: 2, required: false, data: workoutCategories},
                {name: 'onlyShowToday', title: 'Only show today\'s activities', type: 'checkbox', required: false},
                {name: 'weeks', title: 'Show number of weeks', type: 'number', required: true, min: 1},
                {name: 'columns', title: 'Columns', type: 'multiselect', version: 2, required: true, data: [
                    {id: 'startDate', name: 'Date', locked: true},
                    {id: 'startTime', name: 'Time'},
                    {id: 'workoutType.name', name: 'Activity'},
                    {id: 'numBooked', name: 'Number of booked'},
                    {id: 'age', name: 'Age range'},
                    {id: 'instructor', name: 'Instructor'}
                ]}
            ],
            initial: {
                category: workoutCategories,
                weeks: 1,
                columns: ['startDate', 'startTime', 'workoutType.name', 'numBooked', 'age', 'instructor']
            }
        },
        {
            id: 'entrylist',
            name: 'Inpasseringar',
            permissions: 'Entry handling',
            settings: [
                { name: 'resource', title: 'Resource', type: 'multiselect', required: false, data: doors, useId: true, placeholder: 'All' },
                { name: 'daysBack', title: 'How far back in time should the list go', type: 'infoNumber', required: false, info: 'days', min: 0 }
            ]
        },
        {
            id: 'pandemicinfo',
            name: 'Visitor status',
            minwidth: 8,
            settings: []
        },
        {
            id: 'adjusttrainingcardprice',
            name: 'Customers with changed price',
            module: 'TrainingCardPriceAdjustment',
            minwidth: 4,
            settings: []
        },
        {
            id: 'manualentry',
            name: 'Manual entry',
            permissions: 'Entry handling',
            module: 'Entry',
            minwidth: 2,
            settings: [
                { name: 'door', title: 'Door', type: 'select', data: doors, useId: true, required: false, placeholder: 'Choose door' },
            ]
        },
        {
            id: 'lastentry',
            name: 'Last entry',
            permissions: 'Entry handling',
            module: 'Entry',
            minwidth: 8,
            settings: [
                { name: 'resource', title: 'Resource', type: 'multiselect', required: false, data: doors, useId: true, placeholder: 'All' },
                { name: 'fieldsTitle', title: 'Customer fields (title)', type: 'text', required: false },
                { name: 'fields', title: 'Customer fields', type: 'multiselect', data: userfields, required: false, version: 2 }
            ]
        },
        {
            id: 'upcomingresourcebookings',
            name: 'Upcoming resource bookings',
            permissions: 'Show resource bookings',
            module: 'ResourceBooking',
            minwidth: 4,
            settings: [
                { name: 'category', title: 'Category', type: 'select', required: false, data: resourceBookingsCategories },
                { name: 'hoursAhead', title: 'Hours ahead', required: false, type: 'number' },
                { name: 'minutesBefore', title: 'Minutes before', required: false, type: 'number' },
                { name: 'showMine', title: 'Show only mine', required: false, type: 'checkbox' },
                { name: 'displayAttendance', title: 'Display attendance status', required: false, type: 'checkbox' }
            ]
        },
        {
            id: 'korpenmailing',
            name: 'Korpen personalutskick',
            permissions: 'Schedule handling',
            module: 'KorpenMailing',
            settings: []
        },
        {
            id: 'unconfirmedresourcebookings',
            name: 'Unconfirmed resource bookings',
            permissions: 'Resource booking',
            module: 'ResourceBooking',
            settings: [
                { name: 'category_id', title: 'Categories', type: 'multiselect', data: resourceBookingsCategories, useId: true, placeholder: 'Show all categories' },
                { name: 'resource_id', title: 'Resources', type: 'customers', itemTypes: ['staff', 'resource'], useId: true, placeholder: 'Show all resources', data: staffsAndResources },
                { name: 'only_show_mine', title: 'Only show mine', type: 'checkbox' }
            ]
        }
    ];

    function updateTranslation() {
        widget_list.forEach(function(widget) {
            widget.translated = util.t(widget.name);

        });
    }
    updateTranslation();
    $rootScope.$on('$translateChangeSuccess', updateTranslation);

    widgets.getWidgets = function() {
        var type_filter = {
            economy: ['economy', 'report']
        };
        return widget_list.filter(function(w) { return (type_filter[widgets.type] ? type_filter[widgets.type].indexOf(w.type) != -1 : true) && (w.module ? $rootScope.hasModule(w.module) : true); });
    };

    function getAddonWidgets() {
        widget_list.filterInPlace(function(w) { return !w.addon; });
        server.get('/api/addon/widget/get').then(function(widgets) {
            widgets.forEach(function(w) {
                if (w.type && w.type != 'staffdashboard') {
                    return;
                }

                var widget = {};
                widget.addon = w.addon;
                widget.id = 'addon_' + w.addon + w.name;
                widget.name = w.name;
                widget.type = w.subtype;
                widget.permissions = w.permissions;
                widget.settings = angular.copy(_.findWhere(widget_list, {id: 'iframewidget'}).settings);
                widget.settings.forEach(function(s) {
                    s.visible = function() { return false; };
                });
                widget.initial = {
                    url: w.url,
                    pass_zoezi_user_id: true
                };
                w.settings.forEach(function(ws) {
                    widget.settings.push({name: ws.name, title: ws.title, type: ws.type, required: ws.required});
                    if (ws.default !== undefined) {
                        widget.initial[ws.name] = ws.default;
                    }
                });
                widget.translated = w.name;
                widget_list.push(widget);
            });
        });
    }
    getAddonWidgets();
    live.subscribe({ type: 'addon', callback: getAddonWidgets });

    return widgets;
}]);

dashboard.directive('widget', ['$compile', function($compile) {
    return {
        restrict: 'E',
        scope: {
            config: '=',
            control: '=?'
        },
        link : function($scope, element) {
            var render = function() {
                var widget_name = $scope.config.widget.startsWith('addon_') ? 'iframewidget' : $scope.config.widget;
                var html = '<{0} settings="config.settings" control="control"/>'.format(widget_name);
                var e = angular.element(html);
                element.empty();
                element.append(e);
                $compile(e)($scope);
            };

            $scope.$watch('config', function(newValue) {
                if (newValue) {
                    render();
                }
            });

            if ($scope.control) {
                $scope.control.reload = function() {
                    render();
                };
            }
        }
    };
}]);

dashboard.controller('AccessDataCtrl', ['$rootScope', '$scope', 'util', 'options', function($rootScope, $scope, util, options) {
    function nobodyCanEdit() {
        var fields = ['change_persons', 'change_groups', 'change_groupleaders', 'change_roles'];
        for (var i=0; i < fields.length; ++i) {
            var v = $scope.config.control.getField(fields[i]).value;
            if (v && v.length) {
                return false;
            }
        }
        return true;
    }

    $scope.config = _.deep_extend(options.config, {
        tabs: [
            {
                name: 'Access for changing',
                fields: [
                    {value: 'DASHBOARDCHANGEINFO', type: 'alert', class: 'alert-info'},
                    {name: 'change_persons', title: 'Persons', type: 'customers', required: false, itemTypes: ['staff'], useId: true },
                    {name: 'change_groups', title: 'Groups', type: 'groups', required: false, useId: true, placeholder: 'Click to give access to group' },
                    {name: 'change_groupleaders', title: 'Group leaders', type: 'groups', required: false, useId: true, placeholder: 'Click to give access to group leaders' },
                    {name: 'change_roles', title: 'Roles', type: 'multiselect', required: false, options: function() { return $rootScope.roles; }, useId: true, placeholder: 'Click to give access to role' },
                    {value: 'Someone must be allowed to edit the dashboard', type: 'alert', class: 'alert-danger', visible: nobodyCanEdit }
                ]
            },
            {
                name: 'Access for only using',
                fields: [
                    {value: 'DASHBOARDUSEINFO', type: 'alert', class: 'alert-info'},
                    {name: 'use_all_staff', title: 'All staff', type: 'checkbox' },
                    {name: 'use_persons', title: 'Persons', type: 'customers', required: false, itemTypes: ['staff'], useId: true, visible: '!use_all_staff' },
                    {name: 'use_groups', title: 'Groups', type: 'groups', required: false, useId: true, placeholder: 'Click to give access to group', visible: '!use_all_staff' },
                    {name: 'use_groupleaders', title: 'Group leaders', type: 'groups', required: false, useId: true, placeholder: 'Click to give access to group leaders', visible: '!use_all_staff' },
                    {name: 'use_roles', title: 'Roles', type: 'multiselect', required: false, options: function() { return $rootScope.roles; }, useId: true, placeholder: 'Click to give access to role', visible: '!use_all_staff' }
                ]
            }
        ],
        canSubmit: function() {
            return !nobodyCanEdit();
        }
    });
}]);

dashboard.controller('WidgetDataCtrl', ['$rootScope', '$scope', 'util', 'widgets', 'options', '$q', function($rootScope, $scope, util, widgets, options, $q) {
    function setTitle() {
        var widget = $scope.config.control.getField('widget').value;
        $scope.config.control.getField('title').value = util.t(widget.name);
    }
    function widgetChanged() {
        setTitle();
        _.findWhere($scope.config.tabs, {name: 'Settings'}).fields.length = 0;
        $scope.config.control.getFieldsForTab('General').filterInPlace(function(field) { return !field.name || field.name.indexOf('.') == -1; });
        var widget = $scope.config.control.getField('widget').value;

        $q.when(Promise.allSettled([widget.loadData?.()])).then(() => {
            // Angular digest cycle will run automatically now

            util.addQuestions(_.findWhere($scope.config.tabs, {name: 'Settings'}).fields, widget.settings, 'settings');

            var report = $scope.config.control.getField('settings.report_id');
            if (report) {
                report.change = function() {
                    $scope.config.control.getField('title').value = util.t(report.value.name);
                };
                report.orderPredicate = 'name';
            }

            var values = {settings: options.item ? options.item.settings : widget.initial};
            util.setValues(_.findWhere($scope.config.tabs, {name: 'Settings'}).fields, values);

            var allActivities = $scope.config.control.getField('settings.onlyShowToday');
            if (allActivities) {
                allActivities.change = function() {
                    $scope.config.control.getField('settings.weeks').visible = function() { return !allActivities.value; };
                    $scope.config.control.getField('title').value = allActivities.value ? 'Dagens aktiviteter' : 'Alla aktiviteter';
                    var columns = $scope.config.control.getField('settings.columns').value;
                    if (allActivities.value) {
                        $scope.config.control.getField('settings.columns').value = _.filter(columns, function(c) { return c.id !== 'startDate'; });
                    } else {
                        var data = [
                            {id: 'startDate', name: 'Date', locked: true},
                            {id: 'startTime', name: 'Time'},
                            {id: 'workoutType.name', name: 'Activity'},
                            {id: 'origin.numBooked', name: 'Number of booked'},
                            {id: 'age', name: 'Age range'},
                            {id: 'instructor', name: 'Instructor'}
                        ];
                        $scope.config.control.getField('settings.columns').value = _.filter(data, function(d) { return d.id === 'startDate' || _.findWhere(columns, {id: d.id}); });
                    }
                };
            }
        });
    }
    function hasPermissionForWidget(widget) {
        var permissions = widget.permissions ? (Array.isArray(widget.permissions) ? widget.permissions : [widget.permissions]) : [];
        return _.all(permissions, $rootScope.hasPermission);
    }
    $scope.config = _.deep_extend(options.config, {
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'widget', title: 'Widget', type: 'select', required: true, options: widgets.getWidgets, optionsFilter: hasPermissionForWidget, useId: true, change: widgetChanged, orderPredicate: 'translated'},
                    {name: 'showheader', title: 'Show header', type: 'checkbox'},
                    {name: 'title', title: 'Title', type: 'text', required: true, visible: 'showheader'},
                    {hint: 'This widget requires a wider box', hintClass: 'alert-danger', visible: function() { var w = $scope.config.control.getField('widget'); return w.value && w.value.minwidth && w.value.minwidth > options.width; }}
                ]
            },
            {
                name: 'Settings',
                fields: [],
                visible: function() {
                    return $scope.config.control.getFieldsForTab('Settings').filter(function(f) { return !f.visible || f.visible(); }).length > 0;
                }
            }
        ],
        canSubmit: function() {
            var w = $scope.config.control.getField('widget').value;
            var minwidth = w.minwidth;
            return !minwidth || minwidth <= options.width;
        },
        getSubmitItem: function() {
            var widget = $scope.config.control.getField('widget').value;
            var item = $scope.config.control.getSubmitItem();
            item.minwidth = $scope.config.control.getField('widget').value.minwidth;
            Object.keys(widget.initial || {}).forEach(function(setting) {
                if (!item.settings || item.settings[setting] == undefined) {
                    if (!item.settings) {
                        item.settings = {};
                    }
                    item.settings[setting] = widget.initial[setting];
                }
            });
            return item;
        },
        canRemove: function() {
            return options.item;
        },
        remove: function() {
            $scope.$close(null);
        },
        init: function() {
            if (options.item) {
                if (options.item.widget) {
                    util.setValues($scope.config.tabs[0].fields, {widget: options.item.widget}, {callChange: true});
                }
            } else {
                return {
                    showheader: true
                };
            }
        }
    });
}]);